import { useTranslation } from "react-i18next";
import { useNavigateBack } from "../../hooks/useNavigationBack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";

export const SEOCheckerApp = () => {
    const { t } = useTranslation('toolsApps');
    const navigateBack = useNavigateBack();

    useEffect(()=>{
        document.title = t('apps:registry.app.seoChecker.name')
    },[]);
    //TODO:send first hidden message with job definition in backend and get chatID 
    return(<>
        <div className='row p-2 border-bottom border-secondary'>
          <div className='col-auto p-2 pe-0'>
              <button 
                  onClick={() => navigateBack()} 
                  className="btn btn-outline-secondary btn-sm ms-3"
                  title={t('toolsApps:back')}
              >
              <FontAwesomeIcon
                      icon={faArrowLeftLong}
                      size="1x"
                      title={t('back')}
                  />
              </button>
          </div>
        </div>
    </>)
}

export default SEOCheckerApp;

